import * as actions from '../actions/actions'

const otp = (state = {}, action) => {
  switch (action.type) {
    case actions.SET_OTP_DETAILS:    
      return Object.assign({},state,action.otp);   
    case actions.SET_OTP_PHONE:
      return Object.assign({},state,{phone:action.phone});
    case actions.SET_OTP_TOKEN:
      return Object.assign({},state,{token:action.token});
    default:
      return state;
  }
}

export default otp


// WEBPACK FOOTER //
// ./src/reducers/otp.js